export default __webpack_public_path__ + "static/media/editclips.7c6aebe7.png";